export const LIST_EXCHANGE_API = "LIST_EXCHANGE_API";
export const ADD_EXCHANGE_API = "ADD_EXCHANGE_API";
export const LIST_ADMIN_KPI = "LIST_ADMIN_KPI";
